import { Action } from "redux";

import { AggregationFunction, ConditionParams } from "@multiweb/clients/dataReader";
import { TypedObject } from "@multiweb/types/react";
import { CLEAR, SET_RESULT } from "./constants";

/**
 * Struktura stavu modulu ReportingScalar.
 */
export type IReportingScalarState = TypedObject<ReportingScalar>;

interface IMappedAction extends Action<string> {
    readonly meta: {
        readonly dataKey: string;
    };
}

class IMappedAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance?.meta?.instanceId;
    }
}

export interface IResultAction extends IMappedAction {
    readonly payload: {
        readonly result: string | undefined;
    };
}

export class IResultAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === SET_RESULT;
    }
}

export interface IClearAction extends IMappedAction { }

export class IClearAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === CLEAR;
    }
}

export interface IInitAction extends IMappedAction {
    readonly payload: {
        readonly aggregationFunction?: AggregationFunction;
        readonly attrName?: string;
        readonly className: string;
        readonly condition: string;
        readonly conditionParams?: ConditionParams;
        readonly displayFormat: string;
        readonly formatProviderKey: string;
        readonly instanceId?: string;
        readonly methodName?: string;
    };
}

export interface IResultFromDataReaderParams {
    readonly aggregationFunction: AggregationFunction;
    readonly attrName: string;
    readonly className: string;
    readonly condition: string;
    readonly conditionParams?: ConditionParams;
}

export type ReportingScalar = Readonly<{
    value: string | undefined;
}>;
